export function AppShowcase() {
  return (
    <section className="py-20 md:py-32 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#DB4789]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#75055B]/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-[#DB4789]/10 rounded-full mb-6">
              <span className="text-sm font-semibold text-[#75055B]">App Preview</span>
            </div>
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6">
              Experience the <span className="bg-gradient-to-r from-[#75055B] to-[#DB4789] bg-clip-text text-transparent">StayApp</span> Difference
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              A beautiful, intuitive interface designed for seamless booking
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 lg:gap-12">
            {/* Left Phone */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-br from-[#75055B]/20 to-[#DB4789]/20 rounded-3xl blur-3xl group-hover:blur-2xl transition-all duration-500" />
              <img
                src="/mobile-app-accommodation-booking-screen.jpg"
                alt="Accommodation Booking"
                className="relative rounded-3xl shadow-2xl w-64 md:w-72 lg:w-80 transform group-hover:scale-105 transition-transform duration-500"
              />
            </div>

            {/* Center Phone - Featured */}
            <div className="relative group -mt-8 md:mt-0 md:-mx-4 z-10">
              <div className="absolute inset-0 bg-gradient-to-br from-[#DB4789]/30 to-[#75055B]/30 rounded-3xl blur-3xl group-hover:blur-2xl transition-all duration-500" />
              <img
                src="/mobile-app-service-categories-interface.jpg"
                alt="Service Categories"
                className="relative rounded-3xl shadow-2xl w-72 md:w-80 lg:w-96 transform group-hover:scale-105 transition-transform duration-500 border-4 border-white"
              />
            </div>

            {/* Right Phone */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-br from-[#75055B]/20 to-[#DB4789]/20 rounded-3xl blur-3xl group-hover:blur-2xl transition-all duration-500" />
              <img
                src="/mobile-app-offers-negotiation-screen.jpg"
                alt="Offers & Negotiation"
                className="relative rounded-3xl shadow-2xl w-64 md:w-72 lg:w-80 transform group-hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
